// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"InstallerAccessScreen_buttonsContainer__zPjse","button":"InstallerAccessScreen_button__cx2+G"};